import React from 'react';
import { Redirect, useHistory, useLocation } from 'react-router';

import { useAppSelector } from '@app/redux/hooks';
import { getavailableMFAMethods } from '@app/redux/mfa/mfa.selectors';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import MFASelector from '../MFASetupPage/components/MFASelector';
import MFA_METHODS_ENUM from '../MFASetupPage/enums/MFA_METHODS.enum';
import Email2FA from './components/Email2FA';
import SMS2FA from './components/SMS2FA';
import TOTP2FA from './components/TOTP2FA';
import WebAuthn2FA from './components/WebAuthn2FA';

const MFAComponents = {
	[MFA_METHODS_ENUM.WEBAUTHN]: WebAuthn2FA,
	[MFA_METHODS_ENUM.EMAIL]: Email2FA,
	[MFA_METHODS_ENUM.TOTP]: TOTP2FA,
	[MFA_METHODS_ENUM.SMS]: SMS2FA,
};

function MFAVerifyPage() {
	const { selectedMFA } = useLocation<{ selectedMFA?: MFA_METHODS_ENUM } | undefined>().state || {};
	const availableMFAMethods = useAppSelector(getavailableMFAMethods);
	const generateRoutePath = useGenerateRoutePath();
	const history = useHistory();

	if (availableMFAMethods) {
		if (availableMFAMethods?.length === 1) {
			const MFAComponent = MFAComponents[availableMFAMethods[0]];
			return <MFAComponent />;
		} else if (selectedMFA) {
			const onDecline = () => history.push(history.location.pathname, { selectedMFA: undefined });
			const MFAComponent = MFAComponents[selectedMFA];
			return <MFAComponent onDecline={onDecline} />;
		} else return <MFASelector availableMFAMethods={availableMFAMethods} isUnauthenticated={true} />;
	} else return <Redirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />;
}

export default MFAVerifyPage;
